import { TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import axios from "axios";
import FormControl from "@material-ui/core/FormControl";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { Autocomplete, Skeleton } from "@material-ui/lab";
import Notification from "../notification/Notification";
import { useTranslation } from "react-i18next";
import { parseAxiosError } from "../../../utils/response";
import { HTTP_STATUSES, STABLE_COIN, STANDARD_ERRORS_WAY } from "../../../utils/consts";

const CurrenciesSelect = ({
  checkedCurrencies,
  setCheckedCurrencies,
  isObject = true,
  defaultOption = false,
  withoutCurrencyType = null
}) => {
  const { t } = useTranslation("otherInterface");

  const [currencies, setCurrencies] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [fetchingCurrencies, setFetchingCurrencies] = useState(true);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/currencies", userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {

        if (withoutCurrencyType) {
          let withoutCurrency = response.data["hydra:member"];

          withoutCurrency = withoutCurrency.filter(item => item.type !== withoutCurrencyType || item.asset === STABLE_COIN);

          return setCurrencies(withoutCurrency);
        }

        setCurrencies(response.data["hydra:member"]);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    }).finally(() => setFetchingCurrencies(false));
  }, []);

  if (forbidden) {
    return "Forbidden";
  }

  if (fetchingCurrencies) {
    return <Skeleton
      variant="rect"
      height={46}
    />;
  }

  if (Object.keys(currencies).length === 0) {
    return "Empty ProjectsContainer";
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <FormControl>
        <Autocomplete
          options={currencies || []}
          value={checkedCurrencies || null}
          onChange={(event, checkedCurrency) => setCheckedCurrencies(checkedCurrency)}
          getOptionLabel={(option) => isObject ? option.asset : option}
          renderInput={(params) => (
            <TextField {...params} label={t("currenciesSelect.title")} />
          )}
          blurOnSelect
          disableClearable={!defaultOption}
        />
      </FormControl>
    </>
  );
};

export default CurrenciesSelect;